import React from "react";
import { Card } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import CardBody from "../../../components/Card/CardBody";
import FormTextTC from "../../../components/Forms/FormTextTC";

export default function Proppos() {
  return (
    <div style={{ height: "100%", width: "100%" }}>
      <Card>
        <CardBody>
          <h3>
            <TranslationWrapper tDefault={"Proppos"} tKey={"producten.form.algemeen.headers.proppos"} />
          </h3>
          <FormTextTC
            name={"proppos_product__proppos_product_id"}
            tDefault={"Proppos product id"}
            tKey={"producten.form.proppos.product_id"}
            tooltip={
              <TranslationWrapper
                tDefault={"The product ID as configured in the Proppos cloud and/or server"}
                tKey={"proppos.proppos_product_id.tooltip"}
              />
            }
            type={"currency"}
          />
        </CardBody>
      </Card>
    </div>
  );
}
